import { mapGetters } from "vuex";
import { XMarkIcon } from "@heroicons/vue/24/outline";
import { FILTER_CONFIG } from "@/constants/filter.constants";

export default {
	name: "ValueDriverModal",
	components: {
		XMarkIcon,
	},
	props: ["isVisible", "valueDriverId", "runAfterLeave"],
	data() {
		return {
			activeDriverId: this.valueDriverId || (this.valueDrivers && this.valueDrivers[0]?.id) || null,
		};
	},
	watch: {
		valueDriverId(newId) {
			if (newId) this.activeDriverId = newId;
		},
		isVisible(visible) {
			if (visible) {
				this.activeDriverId = this.valueDriverId || (this.valueDrivers[0]?.id ?? null);
			}
			document.dispatchEvent(new CustomEvent("modal-state-change", {
				detail: { isOpen: visible },
			}));
		},
		activeDriverId() {
			this.$nextTick(() => {
				const scrollContainer = this.$refs.scrollContainer;
				if (scrollContainer) {
					scrollContainer.scrollTo({
						top: 0,
						behavior: 'smooth'
					});
				}
			});
		},
	},
	computed: {
		...mapGetters("valueDrivers", ["valueDrivers"]),
		...mapGetters("staticContent", ["getTranslations"]),
		currentValueDriver() {
			return this.valueDrivers.find(
				(valueDriver) => valueDriver.id === this.valueDriverId
			);
		},
		title() {
			return this.currentValueDriver?.name;
		},
		description() {
			return this.currentValueDriver?.description;
		},
		iconSrc() {
			return this.currentValueDriver?.image;
		},
		baseURL() {
			return this.$router.resolve({
				name: "LayerScreen",
				params: {
					category: this.$route.params.category,
					sector: this.$route.params.sector,
					layer: FILTER_CONFIG.SOLUTIONS_LAYER_ID,
				},
			}).href;
		},
		activeDriver() {
			const driver = this.valueDrivers.find(d => d.id == this.activeDriverId);
			return driver || {};
		},
	},
	methods: {
		isActiveTab(driver) {
			return driver.id == this.activeDriverId;
		},
		chunkArray(array, chunkSize) {
			const result = [];
			for (let i = 0; i < array.length; i += chunkSize) {
				result.push(array.slice(i, i + chunkSize));
			}
			return result;
		},
		close() {
			this.$emit("update:isVisible", false);
		},
	},
};
